
<template>
  <div>
        <div class="breadcrumb">
            <Breadcrumb>
                <Breadcrumb-item href="#">市场管理</Breadcrumb-item>
                <Breadcrumb-item>活动列表</Breadcrumb-item>
            </Breadcrumb>
        </div>
        <div class="form">
            <Form :label-width="100" :show-message="false" label-position="left">
                <Row :gutter="32">
                    <Col :xs="11" :sm="6" :md="5">
                        <Form-item :label-width="60" label="活动名称">
                            <Input v-model="queryParams.name" placeholder="请输入活动名称"></Input>
                        </Form-item>
                    </Col>
                    <Col :xs="11" :sm="6" :md="5">
                        <Form-item :label-width="60" label="活动分类">
                            <Col>
                                <Select v-model="queryParams.activityType" clearable>
                                  <Option v-for="item in $constant.activityType" :value="item.code" :key="item.code">{{ item.text }}</Option>
                                </Select>
                            </Col>
                        </Form-item>
                    </Col>
                    <Col :xs="11" :sm="6" :md="5">
                        <Form-item :label-width="40" label="状态">
                            <Select v-model="queryParams.status" clearable>
                              <Option value="1" key="1">启用</Option>
                              <Option value="0" key="2">禁用</Option>
                            </Select>
                        </Form-item>
                    </Col>
                    <Col :xs="11" :sm="6" :md="5">
                      <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search" @click="search">搜索</Button>
                    </Col>
                </Row>
                <Row justify="end" type="flex">
                    <Button type="primary" :loading="searchLoading" :disable="searchLoading" @click="toShowAddActivityModal">新建活动</Button>
                    <!-- <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search" @click="search">搜索</Button> -->
                </Row>
            </Form>
        </div>
        <List style="margin-top: 10px" :tableColumns="tableColumns" listUrl="/activity/page"
                :params="queryParams" :onLoading="onLoading" :reload="reload" @on-selection-change="selectionChange"></List>

        <CreateActivityModal v-model="showAddActivityModal" @on-close="closeModal" :uid="uid" :successCallback="search"></CreateActivityModal>

        <Modal title="编辑活动" v-model="showUpdateActivityModal">
            <Form class="form" ref="updateActivityForm" :rules="activityRules" :model="updateActivityParams">
                <Row>
                    <FormItem :label-width="90" label="海报名称：" prop="name">
                        <Input v-model="updateActivityParams.name" placeholder="请输入活动名称用于列表展示"></Input>
                    </FormItem>
                    <FormItem :label-width="90" label="活动分类：" prop="activityType">
                        <Select v-model="updateActivityParams.activityType" clearable>
                          <Option v-for="item in $constant.activityType" :value="item.code" :key="item.code">{{ item.text }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem :label-width="90" label="活动时间：" prop="activityTime">
                        <DatePicker :value='defaultTime' @on-change="timeDateChange" format="yyyy-MM-dd" type="daterange" placement="bottom-start" placeholder="选择起始时间"></DatePicker>
                    </FormItem>
                    <FormItem :label-width="90" label="活动标识：" prop="tag">
                        <Input v-model="updateActivityParams.tag" placeholder="请输入活动标识"></Input>
                    </FormItem>
                    <FormItem :label-width="90" label="活动状态：" prop="status">
                        <Select v-model="updateActivityParams.status" clearable>
                            <Option value="yes" key="1">启用</Option>
                            <Option value="no" key="2">禁用</Option>
                        </Select>
                    </FormItem>
                    <FormItem :label-width="90" label="活动说明：">
                        <Input v-model="updateActivityParams.description" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入活动描述" />
                    </FormItem>
                </Row>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="showUpdateActivityModal = false">取消</Button>
                <Button type="primary" size="large" :loading="loadingAddActivity" @click="updateActivity">确定</Button>
            </div>
        </Modal>
  </div>
</template>

<script>
import CreateActivityModal from './modal/CreateActivityModal.vue';
export default {
    components: {
        CreateActivityModal
    },
    data(){
        let $constant = this.$constant
        return {
            selectDefaultImages: [],
            selectionUser: [],
            reload: 0,
            onLoading: false,
            searchLoading: false,
            loadingAddActivity: false,
            showAddActivityModal: false,
            showUpdateActivityModal: false,
            defaultTime: [],
            updateActivityParams: {
                id: 0,
                name: '',
                activityType: '',
                tag: '',
                startTimeStr: '',
                endTimeStr: '',
                status: '',
                description: '',
                createTime: '',
                updateTime: ''
            },
            queryParams: {
                 name: '',
                 activityType: '',
                 status: ''
            },
            activityRules: {
                name: [
                    { type: 'string', required: true, message: '请输入活动名称', trigger: 'blur' }
				],
				activityType: [
                    { type: 'string', required: true, message: '请选择活动分类', trigger: 'blur' }
				],
				activityTime: [
                    { type: 'array', required: true, fields: {
                        0: { required: true, message: ' ', trigger: 'change' },
                        1: { required: true, message: ' ', trigger: 'change' }
                    }}
				],
				tag: [
                    { type: 'string', required: true, message: '请输入活动参数', trigger: 'blur' }
				],
				status: [
                    { type: 'integer', required: true, message: '请选择活动状态', trigger: 'blur' }
				]
            },
            tableColumns: [
                {
                    type: 'selection',
                    // width: 60,
                    align: 'center'
                },
                {
                    title: '活动Id',
                    // width: 80,
                    align: 'center',
                    key: 'id'
                },
                {
                    title: '活动名称',
                    // width: 150,
                    align: 'center',
                    key: 'name'
                },
                {
                    title: '活动分类',
                    // width: 120,
                    align: 'center',
                    key: 'activityType',
                    render: (h, params) => {
                        let row = params.row
                        return h('div', $constant.getEnum($constant.activityType, row.activityType).text)
                    }
                },
                {
                    title: '活动标识',
                    // width: 120,
                    align: 'center',
                    key: 'tag'
                },
                {
                    title: '活动时长',
                    width: 250,
                    align: 'center',
                    key: 'receiverName',
                    render: (h, params) => {
                        let row = params.row
                        return h('div',[
                            h('div', '开始时间：'+ row.startTime),
                            h('div', '结束时间：'+ row.endTime)
                        ])
                    }
                },
                {
                    title: '状态',
                    // width: 120,
                    align: 'center',
                    key: 'status',
                    render: (h, params) => {
                        let row = params.row
                        return h('div', row.status === 1 ? '启用' : '禁用')
                    }
                },
                {
                    title: '活动描述',
                    // width: 180,
                    align: 'center',
                    key: 'description'
                },
                {
                    title: '创建时间',
                    // width: 180,
                    align: 'center',
                    key: 'createTime'
                },
                {
                    title: '操作',
                    // width: 130,
                    align: 'center',
                    render: (h, params) => {
                        let row = params.row
                        return h('div',[
                            h('a', { on: { click: () => this.showUpdateActivity(row) } },'编辑'),
                        ])
                    }

                }
            ]
        }
    },
    mounted: function () {
    },
    created: function () {
    },
    methods: {
        timeDateChange(value){
            console.log(`value`, value)
            let self = this
            self.createActivityForm.startTimeStr = value[0] + ' 00:00:00'
            self.createActivityForm.endTimeStr = value[1] + ' 23:59:59'
        },
        toShowAddActivityModal () {
            let self = this
            self.showAddActivityModal = true
        },
        showUpdateActivity (row) {
            let self = this
            self.updateActivityParams.id = row.id
            self.updateActivityParams.name = row.name
            self.updateActivityParams.activityType = row.activityType
            self.updateActivityParams.tag = row.tag
            self.updateActivityParams.status = row.status == '1'  ? 'yes' : 'no'
            self.updateActivityParams.description = row.description
            self.updateActivityParams.createTime = row.createTime
            self.updateActivityParams.updateTime = row.updateTime
            self.updateActivityParams.startTimeStr = row.startTime
            self.updateActivityParams.endTimeStr = row.endTime
            self.defaultTime = [row.startTime, row.endTime]
            self.showUpdateActivityModal = true
        },
        search () {
            this.selectionUser = []
            this.reload = new Date().getTime()
        },
        selectionChange (selection) {
            this.selectionUser = selection
        },
        updateActivity () {
            let self = this
            self.updateActivityParams.status = self.updateActivityParams.status == 'yes' ? 1 : 0
            self.$refs.updateActivityForm.validate((valid) => {
                if (!valid) {
                self.$Message.warning('信息输入错误!')
                self.loadingAddActivity = false
                return
                }
                self.$http.post('/activity/update', self.updateActivityParams).then(res => {
                    if(res){
                        self.$message.success('修改成功')
                        self.showUpdateActivityModal = false
                        self.search()
                    }
                }).catch(err => {
                    console.log(`err`, err)
                    self.$message.error(err)
                })
            })
            
        },
        closeModal (val) {
            this.uid = null
            this.editUser = false
        },
    }

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// ActivityList.vue?4ac57ca7